// extracted by mini-css-extract-plugin
export default {"wrapper":"nA-z","button":"oA-z","alternate":"pA-z","disabled":"qA-z","paymentWarning":"rA-z","fadeIn":"sA-z"};